import React from "react"

import Link from "~components/Link"

const List = ({
  microcopy, id, showTitle = false, showCopyright = false,
}) => (
  <ul>
    {showCopyright && (
    <li>
      &copy;
      {new Date().getFullYear()}
      {' '}
      Box
    </li>
    )}
    {showTitle && <li>{microcopy.text(`${id}.title`)}</li>}
    {Object.entries(microcopy.text(`${id}.links`, {})).map(([key, link]) => (
      <li key={key}>
        <Link to={link.url} microcopy={microcopy}>
          {link.text}
        </Link>
      </li>
    ))}
  </ul>
)

export default List
